import _ from 'lodash';
import GatewayService from '../GatewayService.js';
import log from '../log.js';
var assignmentService = new GatewayService('assignment-service');
var VALID_ASSIGNMENT_TYPES = ['Cardstack', 'Lesson', 'Custom-Content']; // AssignmentType needs to be backwards compatible with pre-custom-content assignments,
// when the param was `isCardstackAssignment = true`. If the argument is of type string,
// we just use plug in that string, otherwise we assume it is a bool and treat it like
// we did when it was isCardstackAssignment.

var createAssignment = function createAssignment(breadcrumbs, classBks, dueDate, startDate, assignmentType) {
  var type;

  if (typeof assignmentType === 'string') {
    if (!VALID_ASSIGNMENT_TYPES.includes(assignmentType)) {
      log.error("Assignment not created. Invalid assignment type ".concat(assignmentType));
      return Promise.reject("Assignment not created. Invalid assignment type ".concat(assignmentType));
    }

    type = assignmentType;
  } else {
    type = assignmentType ? 'Cardstack' : 'Lesson';
  }

  var assignedContent = _.map(breadcrumbs, function (breadcrumb) {
    return {
      content: breadcrumb,
      type: type
    };
  });

  var body = {
    dueDate: dueDate,
    assignedContent: assignedContent,
    classBks: classBks,
    startDate: startDate
  };
  return assignmentService.post('', body);
}; // AssignmentType needs to be backwards compatible with pre-custom-content assignments,
// when the param was `isCardstackAssignment = true`. If the argument is of type string,
// we just use plug in that string, otherwise we assume it is a bool and treat it like
// we did when it was isCardstackAssignment.


var updateAssignment = function updateAssignment(assignmentBK, breadcrumbs, classBks, dueDate, startDate, assignmentType) {
  var existingAssignedContent = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var type;

  if (typeof assignmentType === 'string') {
    if (!VALID_ASSIGNMENT_TYPES.includes(assignmentType)) {
      log.error("Assignment not created. Invalid assignment type ".concat(assignmentType));
      return Promise.reject("Assignment not created. Invalid assignment type ".concat(assignmentType));
    }

    type = assignmentType;
  } else {
    type = assignmentType ? 'Cardstack' : 'Lesson';
  }

  var assignedContent = _.map(breadcrumbs, function (breadcrumb) {
    var assignedContentItem = {
      content: breadcrumb,
      type: type
    };
    var existingContentItem = existingAssignedContent.find(function (item) {
      return item.content.cardstackKey === breadcrumb.cardstackKey;
    });

    if (existingContentItem && existingContentItem.contentBusinessKey) {
      assignedContentItem.contentBusinessKey = existingContentItem.contentBusinessKey;
    }

    return assignedContentItem;
  });

  var body = {
    businessKey: assignmentBK,
    dueDate: dueDate,
    assignedContent: assignedContent,
    classBks: classBks,
    startDate: startDate
  };
  return assignmentService.put('', body);
};

var getAssignment = function getAssignment(assignmentBK) {
  return assignmentService.get("".concat(assignmentBK));
};

var deleteAssignment = function deleteAssignment(assignmentBK) {
  return assignmentService["delete"](assignmentBK);
};

var fetchUserAssignments = function fetchUserAssignments(userKey) {
  var showPastDueAssignments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var showNotStartedAssignments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var sinceTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var startOrCreatedDateSorting = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var archived = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
  var showStatuses = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var domain = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
  var showContentStatuses = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
  var workType = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
  var includeSingleSessionCodes = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : false;
  var includeHeaders = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : false;
  var limitParamString = limit ? "&limit=".concat(limit) : '';
  var offsetParamString = offset ? "&offset=".concat(offset) : '';
  var startOrCreatedDateSortingParamString = startOrCreatedDateSorting ? '&startOrCreatedDateSorting=true' : '';
  var archivedParamString = "&archived=".concat(archived);
  var showStatusesParamString = showStatuses ? "&showStatuses=".concat(showStatuses) : '';
  var domainParamString = domain ? "&domain=".concat(domain) : '';
  var showContentStatusesParamString = showContentStatuses ? "&showContentStatuses=".concat(showContentStatuses) : '';
  var workTypeParamString = workType ? "&workType=".concat(workType) : '';
  var includeSingleSessionCodesParamString = includeSingleSessionCodes ? '&includeSingleSessionCodes=true' : '';
  var queryString = "?ignoreDueDate=".concat(showPastDueAssignments, "&showPending=").concat(showNotStartedAssignments) + startOrCreatedDateSortingParamString + offsetParamString + limitParamString + archivedParamString + showStatusesParamString + domainParamString + showContentStatusesParamString + workTypeParamString + includeSingleSessionCodesParamString;

  if (sinceTime) {
    return assignmentService.get("user/".concat(userKey, "/since/").concat(sinceTime).concat(queryString));
  } else {
    if (includeHeaders) {
      return assignmentService.getWithHeaders("user/".concat(userKey).concat(queryString));
    }

    return assignmentService.get("user/".concat(userKey).concat(queryString));
  }
};

var fetchClassAssignments = function fetchClassAssignments(classKey) {
  var showPastDueAssignments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var showNotStartedAssignments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var startOrCreatedDateSorting = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var archived = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  var domain = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var workType = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var includeHeaders = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
  var limitParamString = limit ? "&limit=".concat(limit) : '';
  var offsetParamString = offset ? "&offset=".concat(offset) : '';
  var startOrCreatedDateSortingParamString = startOrCreatedDateSorting ? '&startOrCreatedDateSorting=true' : '';
  var archivedParamString = "&archived=".concat(archived);
  var domainParamString = domain ? "&domain=".concat(domain) : '';
  var workTypeParamString = workType ? "&workType=".concat(workType) : '';
  var queryString = "?ignoreDueDate=".concat(showPastDueAssignments, "&showPending=").concat(showNotStartedAssignments) + startOrCreatedDateSortingParamString + offsetParamString + limitParamString + archivedParamString + domainParamString + workTypeParamString;

  if (includeHeaders) {
    return assignmentService.getWithHeaders("class/".concat(classKey).concat(queryString));
  }

  return assignmentService.get("class/".concat(classKey).concat(queryString));
};

var updateReadContentStatuses = function updateReadContentStatuses(studentBusinessKey, assignmentBusinessKey, contentBusinessKeys) {
  return updateContentStatuses('READ', studentBusinessKey, assignmentBusinessKey, contentBusinessKeys);
};

var updateHandedInContentStatuses = function updateHandedInContentStatuses(studentBusinessKey, assignmentBusinessKey, contentBusinessKeys) {
  return updateContentStatuses('HANDED IN', studentBusinessKey, assignmentBusinessKey, contentBusinessKeys);
};

var updateContentStatuses = function updateContentStatuses(status, studentBusinessKey, assignmentBusinessKey, contentBusinessKeys) {
  var body = {
    studentBusinessKey: studentBusinessKey,
    assignmentBusinessKey: assignmentBusinessKey,
    status: status,
    contentStatuses: contentBusinessKeys.map(function (contentBusinessKey) {
      return {
        status: status,
        contentBusinessKey: contentBusinessKey
      };
    })
  };
  return assignmentService.post('status', body);
};

export default {
  createAssignment: createAssignment,
  fetchUserAssignments: fetchUserAssignments,
  fetchClassAssignments: fetchClassAssignments,
  deleteAssignment: deleteAssignment,
  getAssignment: getAssignment,
  updateAssignment: updateAssignment,
  updateReadContentStatuses: updateReadContentStatuses,
  updateHandedInContentStatuses: updateHandedInContentStatuses
};